import { Component } from '@angular/core';

@Component({
  selector: 'app-docs-service',
  templateUrl: './docs-service.component.html',
  styleUrl: './docs-service.component.scss',
})
export class DocsServiceComponent {
  items = [
    {
      title: 'وصف ',
      content:
        '   ​​عند تقديمك للحصول على بعض الخدمات من خلال مركز خدمات المستثمرين, قد يطلب منك الموظف استيفاء بعض المستندات الناقصة , من خلال هذه الخدمة يمكنك ارسال المستندات ألكترونيا لاستكمال الخدمة دون حملها على وسيط ومن أي مكان  ',
      expanded: false,
    },
    {
      title: '  المتطلبات الأساسية',
      content: '​اسم الشركة ',
      expanded: false,
    },
    {
      title: ' المستندات المطلوبة ',
      content: ' ​المستندات التي يطلبها الموظف المختص',
      expanded: false,
    },
    {
      title: 'الرسوم جنيه مصرى  ',
      content: '​لايوجد ',
      expanded: false,
    },
    {
      title: ' الإطار الزمني ',
      content: '​يتم تحديد زمن اداء الخدمة وفقا لنوع الخدمة المطلوبة . ',
      expanded: false,
    },
    {
      title: '  قنوات الخدمة',
      content: ' البوابة الالكترونية',
      expanded: false,
    },
    {
      title: '  السياسات والإجراءات',
      content: ` عبر البوابة الإلكترونية

1-     أختر " ارسال مستندات " من " الخدمات الإلكترونية" ثم انقر على "تقدم على الخدمة".

2-     يقوم ممثل عن الشركة بالتسجيل وإنشاء الحساب على الرايط الخاص بالخدمة (أو استخدام حساب منشأ مسبقاً).

3-     يتم استيفاء البيانات المطلوبة في نموذج تقديم الخدمة (اسم الشركة , المركز التابعة له , الإدارة المطلوب توجيه المستند لها). 

4-    يرفق المستندات التي يرغب في ارسالها

* في حالة مواجهة أيه مشكلة أثناء تقديم الطلب إلكترونياً يرجى الاتصال بالخط الساخن علي 16035 `,
      expanded: false,
    },
    {
      title: ' تحميل المستندات المساعدة ',
      content: ' ',
      expanded: false,
    },
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}

// items = [
//   {
//     title: 'وصف ',
//     content: '    ',
//     expanded: false,
//   },
//   {
//     title: ' المتطلبات الأساسية ',
//     content: ' ',
//     expanded: false,
//   },
//     {
//     title: ' المستندات المطلوبة ',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: '  الرسوم جنيه مصرى',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: ' الإطار الزمني ',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: '  ',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: ' قنوات الخدمة ',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: ' السياسات والإجراءات ',
//     content: ' ',
//     expanded: false,
//   },  {
//     title: ' تحميل المستندات المساعدة ',
//     content: ' ',
//     expanded: false,
//   },

// ];
